/** @prettier */
//-------------------------------------
//	グラフに表示するユニットの選択ダイアログ
//-------------------------------------

import {
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  Dialog,
  FormControlLabel,
  Card,
  CardContent,
  Typography,
  Grid,
  FormControl,
  RadioGroup,
  Radio,
} from '@mui/material';
import {useState} from 'react';
import {useTranslation} from 'react-i18next';

//interface import
import * as apiIF from '../Type/api';

/**
 * グラフに表示するユニットの選択ダイアログ（Q-ton）
 * @param props props
 * - isDialogOpen グラフ表示項目選択ダイアログ開閉
 * - setIsDialogOpen グラフ表示項目選択ダイアログ開閉設定関数
 * - parentUnitID 親機のユニットID
 * - parentUnitName 親機のユニット名
 * - childUnitInfo 対象の親機に接続されている子機のユニット名とユニットID一覧
 * - displayUnitID グラフに表示中のユニットのID
 * - displayUnitName グラフに表示中のユニットの名前
 * - setDisplayUnitID グラフに表示するユニットのID
 * - setDisplayUnitName グラフに表示するユニットの名前
 * @returns JSX
 */
const ChangeUnitGraphDialog = (props: {
  isDialogOpen: boolean;
  setIsDialogOpen: React.Dispatch<React.SetStateAction<boolean>>;
  parentUnitID: string;
  parentUnitName: string;
  childUnitInfo: apiIF.resParameters.rtUnitInformations[] | undefined;
  displayUnitID: string;
  displayUnitName: string;
  setDisplayUnitID: React.Dispatch<React.SetStateAction<string>>;
  setDisplayUnitName: React.Dispatch<React.SetStateAction<string>>;
}) => {
  const trans = useTranslation().t; //翻訳関数
  //選択したユニットのID
  const [selectedUnitID, setSelectedUnitID] = useState(props.displayUnitID);
  //選択したユニットの名前
  const [selectedUnitName, setSelectedUnitName] = useState(
    props.displayUnitName
  );
  /**
   * グラフ表示ユニット変更時処理
   * @param event
   */
  const handleChangeUnit = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSelectedUnitID(event.target.value); //選択されたユニットのID
    setSelectedUnitName(event.target.name); //選択されたユニットの名前
  };

  /**
   * CANCELボタン押下時処理
   */
  const handleClose = () => {
    setSelectedUnitID(props.displayUnitID);
    setSelectedUnitName(props.displayUnitName);
    props.setIsDialogOpen(false);
  };
  /**
   * OKボタン押下時処理
   */
  const handleSave = () => {
    props.setDisplayUnitID(selectedUnitID);
    props.setDisplayUnitName(selectedUnitName);
    props.setIsDialogOpen(false);
  };

  return (
    <Dialog
      open={props.isDialogOpen}
      onClose={handleClose}
      aria-labelledby="form-dialog-title"
      maxWidth="md">
      <DialogTitle id="form-dialog-title">
        {trans('ChangeUnitGraphDialog.title')}
      </DialogTitle>
      <DialogContent>
        {/* ダイアログに表示するメッセージ */}
        <DialogContentText>
          {trans('ChangeUnitGraphDialog.msg')}
        </DialogContentText>
        <Grid container columnSpacing={5}>
          <Grid item xs={12}>
            <Card variant="outlined">
              <CardContent>
                <FormControl>
                  <RadioGroup
                    value={selectedUnitID}
                    onChange={handleChangeUnit}>
                    <Typography>
                      {trans('ChangeUnitGraphDialog.parentUnit.heading')}
                    </Typography>
                    <FormControlLabel
                      key={`parentUnit-${props.parentUnitName}`}
                      value={props.parentUnitID}
                      name={props.parentUnitName}
                      control={<Radio />}
                      label={props.parentUnitName}
                    />
                    <Typography>
                      {trans('ChangeUnitGraphDialog.childUnit.heading')}
                    </Typography>
                    {props.childUnitInfo !== undefined ? (
                      props.childUnitInfo.map(info => (
                        <FormControlLabel
                          key={info['unit-id']}
                          value={info['unit-id']}
                          name={info['unit-name']}
                          control={<Radio />}
                          label={info['unit-name']}
                        />
                      ))
                    ) : (
                      <></>
                    )}
                  </RadioGroup>
                </FormControl>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="primary">
          {trans('ChangeUnitGraphDialog.buttonTxt.cancel')}
        </Button>
        <Button onClick={handleSave} color="primary">
          {trans('ChangeUnitGraphDialog.buttonTxt.ok')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
export default ChangeUnitGraphDialog;
